<template>
	<transition name="fade" v-if="config.show">
		<div id="out-modal" class="modal-box">
			<div class="modal modal-sm alert" style="background-color: #f9f9f9;">
				<div class="modal-header p-0 clearfix" style="background-color: #f9f9f9;">
					<a class="close" @click="$emit('close')">×</a>
				</div>
				<!-- //end .modal-header -->
				<div class="modal-body m-t-15 p-0 clearfix">
					<table class="table2 m-t-0">
						<tbody>
							<tr>
								<td class="round">{{config.answerName}}</td>
							</tr>
                            <template v-for="(answer, idx) in config.answerList">
                                <tr class="margin" :key="`${config.answerName}-answer-${answer}-${idx}-margin`">
                                    <td></td>
                                </tr>
                                <tr :key="`${config.answerName}-answer-${answer}-${idx}-value`">
                                    <td class="round">{{answer}}</td>
                                </tr>
                            </template>
						</tbody>
					</table>
				</div>
				<!-- //end .modal-body -->
			</div>
		</div>
	</transition>
</template>

<script>
export default {
	name: "ModalSurveyAnswer",

	default: function() {
		return {
            answerName: "",
            answerList: [],
			name: this.name,
			show: false
		}
	},

	props: {
		config: Object
	},
	methods: {
	},
}
</script>

<style>
    td {white-space: normal !important;}
</style>